import React from 'react'
import './TweetBox.css'
import { Button, Avatar } from '@material-ui/core'
import { useState } from "react"
import db from './firebase'

function TweetBox() {
    const [tweetMessage, setTweetMessage] = useState("");
    const [tweetImage, setTweetImage] = useState("");

    const sendTweet = (e) => {
        e.preventDefault();

        db.collection('posts').add({
            displayName: 'Babahle Mokone',
            username: 'babzini02',
            verified: true,
            text: tweetMessage,
            image: tweetImage,
            avatar: 'https://upload.wikimedia.org/wikipedia/commons/a/a9/God_of_War_Logo.png'
        });

        setTweetMessage("");
        setTweetImage("");
    };


    return (
        <div className='tweetBox'>
            <form>
                <div className='tweetBox_input'>
                    <Avatar src='https://upload.wikimedia.org/wikipedia/commons/a/a9/God_of_War_Logo.png'/>
                    <input 
                    onChange={(e) => setTweetMessage(e.target.value)} 
                    value={tweetMessage} 
                    placeholder="What's Happening?" 
                    type='text'/>
                </div>
                <input 
                onChange={(e) => setTweetImage(e.target.value)}
                value={tweetImage}
                className='tweetBox-imageInput' 
                placeholder="Enter Image URL" 
                type='text'/>
                <Button onClick={sendTweet} className='tweetBox_tweetButton'>Tweet</Button>
            </form>
        </div>
    )
}

export default TweetBox
